/**
 * @internal
 */
import useResizeCallback, { ResizeCallbackTypes, } from '@polestar/component-warehouse-react/hooks/useResizeCallback';
import { useState } from 'react';
import { useMotionValue } from 'framer-motion';
const useDimensionsCallback = (initialDimensions = {}) => {
    const [dimensions, setDimensions] = useState({
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        ...initialDimensions,
    });
    const innerRef = useResizeCallback((node) => {
        const inner = node.getBoundingClientRect();
        setDimensions({
            top: inner.top,
            left: inner.left,
            width: inner.width,
            height: inner.height,
        });
    }, [], ResizeCallbackTypes.both);
    return [innerRef, dimensions];
};
export default useDimensionsCallback;
/**
 * A simplified way of using useResizeCallback only focused on height
 */
export const useHeightCallback = (type = 'clientHeight') => {
    const [height, setHeight] = useState(0);
    const callbackRef = useResizeCallback((node) => {
        setHeight(node[type]);
    }, [type], ResizeCallbackTypes.height);
    return [callbackRef, height];
};
/**
 * A simplified way of using useResizeCallback only focused on height as Framer.MotionValue
 */
export const useHeightMotionValueCallback = (type = 'clientHeight') => {
    const motionValue = useMotionValue(0);
    const callbackRef = useResizeCallback((node) => {
        motionValue.set(node[type]);
    }, [type, motionValue], ResizeCallbackTypes.height);
    return [callbackRef, motionValue];
};
/**
 * A simplified way of using useResizeCallback only focused on width
 */
export const useWidthCallback = (type = 'clientWidth') => {
    const [width, setWidth] = useState(0);
    const callbackRef = useResizeCallback((node) => {
        setWidth(node[type]);
    }, [type], ResizeCallbackTypes.width);
    return [callbackRef, width];
};
/**
 * A simplified way of using useResizeCallback only focused on width as Framer.MotionValue
 */
export const useWidthMotionValueCallback = (type = 'clientWidth') => {
    const motionValue = useMotionValue(0);
    const callbackRef = useResizeCallback((node) => {
        motionValue.set(node[type]);
    }, [type, motionValue], ResizeCallbackTypes.width);
    return [callbackRef, motionValue];
};
